/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import Grid from '@material-ui/core/Grid';
import { bool } from 'prop-types';
import useStyles from './ZodiacTopBannerStyles';

const ZodiacTopBanner = ({ isSmallScreen }) => {
    const InstagramIcon = 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt0f675275981a4195/63ef7713b0a6397aebc36a5a/instagram.png';
    const styles = useStyles();
    return (
        <div  className={`${styles.zodiacTopBanner} banner-container`}>
            <Grid container spacing={2}>
                <Grid
                    item
                    md={7}
                    className={`${styles.zodiacTopBanner} plants-by-sign-block`}
                >
                    <Grid container spacing={2}>
                        {!isSmallScreen ? (
                            <>
                                <Grid
                                    item
                                    lg={12}
                                    className={`${styles.zodiacTopBanner} in-the-stars`}
                                >
                                    <p
                                        className={`${styles.zodiacTopBanner} sideLineWrapper position-relative`}
                                    >
                                        <span
                                            className={`${styles.zodiacTopBanner} sideLine`}
                                            role="region"
                                            aria-label="IN THE STARS"
                                        >
                                            IN THE STARS
                                        </span>
                                    </p>
                                </Grid>
                                <Grid item lg={12}>
                                    <img
                                        alt="Plants By Sign"
                                        src="https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt634af6f8640b41c8/63f30bdccac5cf7961aa700e/plants_by_sign.png"
                                        width="100%"
                                        height="100%"
                                    />
                                </Grid>
                            </>
                        ) : (
                            <>
                                <Grid item md={12}>
                                    <img
                                        alt="Plants By Sign"
                                        src="https://images.contentstack.io/v3/assets/blt4454dc0093319d35/bltf6832770564d0b95/63f30b9d6e12391086ea7090/in_the_star_plants.png"
                                        width="100%"
                                        height="100%"
                                    />
                                </Grid>
                            </>
                        )}

                        <Grid item md={12} className={`${styles.zodiacTopBanner} description-banner-container`}>
                            <p
                                className={`${styles.zodiacTopBanner} description-banner`}
                                role="banner"
                            >
                                Not sure which plant to pick? Why not let the stars decide! Our
                                expert astrologer, Lisa Stardust, has hand-selected the best
                                houseplants for every sign.
                            </p>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={4} className={`${styles.zodiacTopBanner} astrologer-block`}>
                    <Grid container spacing={3}>
                        <Grid container spacing={3} className={`${styles.zodiacTopBanner} about-lisa`}>
                            <Grid
                                item
                                lg={4}
                                xs={12}
                                className={`${styles.zodiacTopBanner} about-lisa-image`}
                            >
                                <img
                                    alt="Lisa Stardust"
                                    src="https://images.contentstack.io/v3/assets/blt4454dc0093319d35/bltee6fae82dc26ec13/63f37b9b17801132419c8fe2/girl.png"
                                    width={`${isSmallScreen ? '40%' : '80%'}`}
                                    height="100%"
                                />
                            </Grid>
                            <Grid
                                item
                                lg={8}
                                xs={12}
                                className={`${styles.zodiacTopBanner} about-lisa-details`}
                            >
                                <div role="banner" className={`${styles.zodiacTopBanner} about-name`}>
                                    <strong>About Lisa Stardust</strong>
                                </div>
                                <div className={`${styles.zodiacTopBanner} name`} role="banner">
                                    <img
                                        alt="Instagram"
                                        src={InstagramIcon}
                                        width={`${isSmallScreen ? '10%' : '15%'}`}
                                        height={`${isSmallScreen ? '10%' : '15%'}`}
                                    />{' '}
                                    lisastardustastro
                                </div>
                            </Grid>
                        </Grid>
                        <Grid item md={12}>
                            <p
                                className={`${styles.zodiacTopBanner} description`}
                                role="banner"
                            >
                                <strong>Lisa Stardust</strong> is a New York City-based
                                astrologer who has been part of the astrology community for over
                                10 years. She&apos;s an astrological author for{' '}
                                <strong>Oprah Daily, Teen Vogue, Today Show</strong>, and a
                                best-selling author.
                            </p>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};

ZodiacTopBanner.propTypes = {
    isSmallScreen: bool.isRequired,
};

export default ZodiacTopBanner;
